import { validatePassword } from "./passwordValidation";

const PASSWORD_RULE_MESSAGES: Record<string, string> = {
  "At least 8 characters": "Password must be at least 8 characters long",
  "At least one uppercase letter":
    "Password must contain at least one uppercase letter",
  "At least one lowercase letter":
    "Password must contain at least one lowercase letter",
  "At least one number": "Password must contain at least one number",
  "At least one special character":
    "Password must contain at least one special character",
};

export const PORTAL_PASSWORD_REQUIREMENTS =
  "At least 8 characters with uppercase, lowercase, number, and symbol";

export function validatePortalPassword(password: string): string | null {
  const firstUnmetRule = validatePassword(password).rules.find(
    (rule) => !rule.met
  );
  if (firstUnmetRule) {
    return PASSWORD_RULE_MESSAGES[firstUnmetRule.label];
  }
  if (getUtf8ByteLength(password) > 72) {
    return "Password must not exceed 72 bytes";
  }
  return null;
}

export function validatePortalPasswordConfirmation(
  confirmation: string,
  password: string
): string | null {
  return confirmation === password ? null : "Passwords do not match";
}

function getUtf8ByteLength(value: string): number {
  try {
    return encodeURIComponent(value).replace(/%[0-9A-F]{2}/g, "x").length;
  } catch {
    return Number.MAX_SAFE_INTEGER;
  }
}
